import React from 'react';

import Head from 'next/head';

import Footer from '@/components/Footer';
import Header from '@/components/Header';
import SignupFormCategorySelect from '@/components/SignupForm/CategorySelect';

const Category = () => (
  <div className="page-wrapper">
    <Head>
      <meta name="description" content="CallAPro - Find a Home Service Professional Near You" />
      <title>Find Home Service Pros Near You</title>

      <link rel="canonical" href="https://callapro.com/signup/" />
    </Head>
    <Header />
    <SignupFormCategorySelect />
    <Footer />
  </div>
);

export default Category;
